// extracted by mini-css-extract-plugin
export default {"root":"_3Om-Bu-K","headerLink":"xtZqbbUO","headerBtns":"_2NFBdlGr"};